import React, { Component } from 'react'
import PropTypes from 'prop-types'

import FooterNav from './FooterNav'
import FooterAvantLogo from './FooterAvantLogo'

import '../../sass/mainv3.scss'

class FooterV3 extends Component {
  constructor(props) {
    super(props)

    this.state = {
      year: 0
    }
  }

  componentDidMount() {
    const year = new Date().getFullYear()
    this.setState({ year })
  }

  render() {
    const { year } = this.state
    const { data } = this.props

    return data ? (
      <footer className="footer">
        <div className="container__inner">
          <ul className="footer__list">
            <li className="footer__logo-box">
              <FooterAvantLogo imageLink={data.logo} />
            </li>
            <FooterNav linkGroups={data.linkGroups} />
          </ul>

          <div className="social">
            <div className="social__logo-box">
              <p className="social__copywrite">{data.copyright.replace('{year}', year)}</p>
            </div>
            {/* <SocialsIcons imageLinks={socialIcons} /> */}
          </div>
          <p className="social__copywrite desktop">{data.copyright.replace('{year}', year)}</p>
        </div>
      </footer>
    ) : null
  }
}

FooterV3.propTypes = {
  data: PropTypes.object.isRequired
}

/* eslint-disable react/display-name */
export default FooterV3
